module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABJCAMAAAD8DnOOAAAAPFBMVEXvKy36t7j95ubUx9EiQnk1UIT1hYfvKy37xcX////R2OQAKGgYPHb2i4z4qKn95+f7z9D09vjI0d4XO3V29JfcAAAAB3RSTlPc8vr7/v7qRwR7rgAAAHBJREFUeAHt1oEGgDAQh/H/ESsRvf+TNppwkKjpSkbfxzCHH9g203lmvnyzSuqyIlkCuYWAgICAgICAgIBMF7N8RFKJIUNlvkO8fyNzZb7I68sDZNR7gYCANHriuYUbexn5rcQREBAQEBAQEBAQfYBsl7R+jUvz4nsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/no.png
// module id = ZcN6
// module chunks = 0